define('home/templates/activityCardCreate',['handlebars', 'handlebars.partials', 'core/extensions/handlebars.helpers'], function(Handlebars) {

return Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : {};

  return "<div class=\"card-discussion-comments-title\">"
    + container.escapeExpression(helpers.gettext.call(alias1,"Recent Comments",{"name":"gettext","hash":{},"data":data}))
    + "</div>\n<div class=\"card-discussion-comments\" data-role=\"posts\"></div>\n"
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.shouldCollapse : depth0),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "");
},"2":function(container,depth0,helpers,partials,data) {
    return "<div class=\"expandable\">\n<div class=\"card-grouped-actions\">\n<a href=\"#\" data-action=\"toggle-collapsed\" class=\"expandable card-expand\">\n<div class=\"icon-more-vert\"></div>\n"
    + container.escapeExpression(helpers.gettext.call(depth0 != null ? depth0 : {},"See More",{"name":"gettext","hash":{},"data":data}))
    + "\n</a>\n</div>\n</div>\n";
},"4":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "<div class=\"card-summary\">\n<div class=\"card-summary-content\" dir=\"auto\">\n"
    + ((stack1 = container.lambda((depth0 != null ? depth0.threadDescriptionHTML : depth0), depth0)) != null ? stack1 : "")
    + "\n</div>\n</div>\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : {}, alias2=container.escapeExpression;

  return "<div class=\"card-reason\">\n"
    + alias2(helpers.gettext.call(alias1,"%(group)s authored",{"name":"gettext","hash":{"group":helpers.getPartial.call(alias1,"userGroup",{"name":"getPartial","hash":{},"data":data})},"data":data}))
    + "\n<span class=\"time\">"
    + alias2(container.lambda((depth0 != null ? depth0.relativeTime : depth0), depth0))
    + "</span>\n</div>\n"
    + ((stack1 = container.invokePartial(partials.cardTitle,depth0,{"name":"cardTitle","data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.recentPostCount : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(4, data, 0),"data":data})) != null ? stack1 : "")
    + "\n<footer class=\"card-footer\" data-role=\"footer\"></div>\n";
},"usePartial":true,"useData":true})

});
